import React from "react";
import TextField from "@mui/material/TextField";

export const BITextField = ({
  input: { name, onChange, value, ...restInput },
  meta,
  hasError = false,
  errorMessage = null,
  ...rest
}) => {
  return (
    <TextField
      {...rest}
      helperText={
        meta.touched || hasError ? errorMessage || meta.error : undefined
      }
      error={hasError || (meta.error && meta.touched)}
      inputProps={restInput}
      onChange={onChange}
      value={value}
      fullWidth
    />
  );
};

export default BITextField;
